export enum PanelName {
	CommentsPanel = 'commentsPanel',
	DetailsPanel = 'detailsPanel',
	WorkflowsPanel = 'workflowsPanel',
}
